'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import DurationPicker from 'MeetingsLib/components/schedule/duration/DurationPicker';
import SkeletonTimePicker from 'MeetingsLib/components/schedule/time/SkeletonTimePicker';
import TimePickerV2 from '../schedule/time/TimePickerV2';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
import { getIsUngatedForAvailabilityDaysLimit } from 'MeetingsLib/selectors/BookInfoSelectors';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TimeOptionsSection extends Component {
  constructor(...args) {
    super(...args);
    this.handleGoToPreviousStep = () => {
      const {
        resetEventDateTime,
        goToPreviousStep
      } = this.props;
      resetEventDateTime();
      goToPreviousStep();
    };
    this.renderTimePicker = () => {
      const {
        branding,
        compact,
        isFetchingPublicAvailability,
        profile,
        TimePickerMarker
      } = this.props;
      if (isFetchingPublicAvailability) {
        return /*#__PURE__*/_jsx(SkeletonTimePicker, {});
      }
      return /*#__PURE__*/_jsx(TimePickerV2, {
        branding: branding,
        compact: compact,
        profile: profile,
        TimePickerMarker: TimePickerMarker
      });
    };
    this.renderStepButtonsFooter = () => {
      const {
        branding,
        compact
      } = this.props;
      if (!compact) {
        return null;
      }
      return /*#__PURE__*/_jsx(StepButtonsFooter, {
        branding: branding,
        compact: compact,
        goToPreviousStep: compact ? this.handleGoToPreviousStep : null
      });
    };
  }
  render() {
    const {
      compact
    } = this.props;
    return /*#__PURE__*/_jsxs(CardWrapper, {
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(CardSection, {
        flush: true,
        compact: compact,
        minBlockSize: "100%",
        paddingBlock: "0",
        paddingBlockEnd: compact ? '1000' : '0',
        children: /*#__PURE__*/_jsxs(TFlex, {
          flexDirection: "column",
          marginBlockEnd: "0",
          maxBlockSize: "100%",
          overflow: "hidden",
          inlineSize: "100%",
          children: [/*#__PURE__*/_jsx(View, {
            display: "inline-block",
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(DurationPicker, {})
          }), this.renderTimePicker()]
        })
      }), this.renderStepButtonsFooter()]
    });
  }
}
TimeOptionsSection.propTypes = {
  branding: PropTypes.instanceOf(Branding).isRequired,
  compact: PropTypes.bool.isRequired,
  isFetchingPublicAvailability: PropTypes.bool.isRequired,
  goToPreviousStep: PropTypes.func,
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  resetEventDateTime: PropTypes.func.isRequired,
  TimePickerMarker: PropTypes.func.isRequired
};
export default connect(state => ({
  isUngatedForAvailabilityDaysLimit: getIsUngatedForAvailabilityDaysLimit(state)
}), FormActions)(TimeOptionsSection);